export interface Raffle {
  id: number;
  influencerImage?: string;
  title: string;
  raffleStatus?: string;
  slug?: string;
  ticketsSold: number;
  remainingTickets: number;
  description: string;
  ticketPrice: number;
  ticketCapacity: number;
  raffleStartDate: string;
  raffleEndDate: string;
  ticketSaleStartDate: string;
  ticketSaleEndDate: string;
  isFree?: boolean;
  isUnlimitedCapacity?: boolean;
  isWinner?: boolean;
  raffleWinner?: RaffleWinner;
  createdAt: string;
  modifiedAt: string;
  raffleImages: RaffleImage[];
}

export enum RaffleStatus {
  YetToStart = 'YetToStart',
  Started = 'Started',
  Paused = 'Paused',
  Ended = 'Ended',
  Cancelled = 'Cancelled',
}

export interface RaffleWinner {
  userName: string | null;
  email: string | null;
}

export interface RaffleImage {
  id: number;
  imageUrl: string;
  displayOrder: number;
}

export interface RaffleRequest {
  title: string;
  description: string;
  ticketPrice: number;
  ticketCapacity: number;
  raffleStartDate: string;
  raffleEndDate: string;
  ticketSaleStartDate: string;
  ticketSaleEndDate: string;
  raffleImages: (File | string)[];
}

export interface RaffleRequestViewModel {
  title: string;
  description: string;
  ticketPrice: number;
  ticketCapacity: number;
  raffleStartDate: string;
  raffleEndDate: string;
  ticketSaleStartDate: string;
  ticketSaleEndDate: string;
  raffleImages: RaffleImagesRequestViewModel[];
}

export interface RaffleImagesRequestViewModel {
  imageUrl: string | null;
}

export interface RafflesByInfluencer {
  totalRaffle: number;
  totalRaffleEngagements: number;
  totalRevenue: number;
  raffles: Raffle[];
}
